import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { getExpiresInDays } from "../../utils/Utils";
import Button from "../basic/Button";
import QuestionsDialog from "../profile/QuestionsDialog";

export function AnnouncementQuestonPending() {
  const [showQuestions, setShowQuestions] = useState(false);
  return (
    <div className="flex flex-row w-full py-2 space-x-5 justify-center items-center text-center bg-primary-orange">
      <p className="text-white text-xs">
        Your personalised recommendation is waiting
      </p>
      <QuestionsDialog
        open={showQuestions}
        close={() => {
          setShowQuestions(false);
        }}
      />
      <button
        type="outline"
        className={" border-white py-1 px-2 border-[1px] rounded-full "}
        onClick={() => setShowQuestions(true)}
      >
        <p className="text-white text-sm font-bold font-open-sans">
          Answer these Questions
        </p>
      </button>
    </div>
  );
}

export function AnnouncementTrailExpireSoon() {
  const auth = useAuthContext();
  const navigate = useNavigate();
  return (
    <div className="flex flex-row w-full py-1 space-x-5 justify-center items-center text-center bg-primary-orange">
      <p className="text-white text-xs">
        {getExpiresInDays(auth.state.user.expiresAt) <= 0
          ? "Your Plan has expired"
          : `Your plan expires in ${getExpiresInDays(
              auth.state.user.expiresAt
            )} Days`}
      </p>
      <button
        type="outline"
        className={" border-white py-1 px-2 border-[1px] rounded-full "}
        onClick={() => navigate("/subscription")}
      >
        <p className="text-white text-sm font-bold font-open-sans">
          Subscribe Now
        </p>
      </button>
    </div>
  );
}

export function AnnouncementMaintenance() {
  const auth = useAuthContext();
  const navigate = useNavigate();
  return (
    <div className="flex flex-row w-full py-2 space-x-5 justify-center items-center text-center bg-primary-orange">
      <p className="text-white text-xs">
        We are working on improving and upgrading your fitness experience.
        Please bear with us and we will be right back.
      </p>
    </div>
  );
}
